import React from 'react';
import { instagramUrl, tiktokUrl, youtubeUrl } from './constants/Constants';

function Footer() {
    const instagram = require("./images/instagram.png");
    const youtube = require("./images/youtube.png");
    const tiktok = require("./images/tiktok.png");

    const handleInstagramClick = () => {
        window.open(instagramUrl, '_blank');
    }

    const handleYoutubeClick = () => {
        window.open(youtubeUrl, '_blank');
    }

    const handleTiktokClick = () => {
        window.open(tiktokUrl, '_blank');
    }

    return (
        <div className="footerWrapper">
            <div className="footerJustlyWrapper">
                <div className="footerJustlyName">JUSTLY</div>
            </div>
            <div className="footerSocialMediaWrapper">
                <div className="footerSocialMedia" tabIndex={0} onClick={handleInstagramClick} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleInstagramClick();
                    }
                }}>
                    <img className="footerSocialMediaIcon" src={instagram} alt="instagram"/>
                </div>
                <div className="footerSocialMedia" tabIndex={0} onClick={handleYoutubeClick} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleYoutubeClick();
                    }
                }}>
                    <img className="footerSocialMediaIcon" src={youtube} alt="youtube"/>
                </div>
                <div className="footerSocialMedia" tabIndex={0} onClick={handleTiktokClick} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleTiktokClick();
                    }
                }}>
                    <img className="footerSocialMediaIcon" src={tiktok} alt="tiktok"/>
                </div>
            </div>
        </div>
    );
};

export default Footer;